var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visibleTab
    ? _c(
        "button",
        {
          staticClass: "block relative h-10 w-6",
          attrs: {
            title: _vm.title,
            role: "tab",
            "aria-label": _vm.$t(_vm.a11y.key, { name: _vm.tab }),
            "aria-selected": _vm.activeTab,
            id: "trigger-" + _vm.tab,
            "data-test": "tab-trigger--" + _vm.tab,
            "aria-controls": "tab-" + _vm.tab
          },
          on: { click: _vm.toggle }
        },
        [
          _c(
            "span",
            {
              staticClass: "block absolute top-0",
              style: { color: _vm.contrast }
            },
            [_vm._t("default")],
            2
          ),
          _vm.activeTab
            ? _c(
                "span",
                {
                  staticClass: "block absolute w-full bottom-0",
                  style: { color: _vm.brandDark }
                },
                [
                  _c("icon", {
                    staticClass: "block m-auto",
                    attrs: { type: "active-tab" }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }